var _effectorFileName = "/builds/gmini/front-ui-kit/src/UserProfile/UserProfile.styled.ts";
import styled from 'styled-components';
import { Link, styled as mStyled, Menu as mMenu } from '@mui/material';
export const UserProfileWrap = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  cursor: pointer;
`;
export const IconWrap = styled.div`
  width: 28px;
  height: 28px;
  ${({
  hover
}) => hover && 'width:32px;height:32px'};
  transition: 0.2s ease;
`;
export const IconContainer = styled.div`
  margin-left: 8px;
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
`;
export const UserTitle = styled.div`
  font-family: Open-Sans, Helvetica, Sans-Serif;
  font-size: 12px;
  font-style: normal;
  font-weight: 600;
  line-height: 20px;
  letter-spacing: 0em;
  text-align: right;
  color: ${({
  hover
}) => hover ? 'rgba(0, 0, 61, 1)' : '#353B60'};
`;
export const StyledLink = mStyled(Link)({
  color: 'inherit',
  textDecoration: 'none',
  '&:hover': {
    textDecoration: 'none'
  }
});
export const Menu = mStyled(mMenu)({
  '& .MuiPaper-elevation8': {
    boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.25)'
  },
  '& .MuiListItem-button:hover': {
    background: 'rgba(0, 5, 100, 0.04)'
  },
  '& .MuiListItemIcon-root': {
    minWidth: '24px'
  }
});
export const MenuItem = mStyled(mMenu)({
  color: '#000335',
  letterSpacing: '0.1px',
  fontSize: '16px'
});